import type { TranslationCatalog } from "../types.js";

function coinWord(n: number): string {
  const mod10 = Math.abs(n) % 10;
  const mod100 = Math.abs(n) % 100;
  return mod10 === 1 && mod100 !== 11 ? "монета" : "монети";
}

export default {
  "common.loading": "Поврзување...",
  "common.loadingEllipsis": "Вчитување...",
  "common.unknownError": "Непозната грешка",
  "common.errorPrefix": (p: { message: string }) => `Грешка: ${p.message}`,
  "common.retry": "Обиди се повторно",
  "common.close": "Затвори",
  "common.back": "← Назад",
  "common.cancel": "Откажи",
  "common.details": "Детали",
  "common.settingsTitle": "⚙️ Поставки",
  "common.profile": "👤 Профил",
  "common.rules": "📖 Правила",

  "login.subtitle": "Најави се за да играш.",
  "login.continueFacebook": "Продолжи со сметка на Facebook",
  "login.continueGoogle": "Продолжи со сметка на Google",
  "login.continueEmail": "Продолжи со е-пошта",
  "login.tagline": "Картичка игра со адут и лицитација за тројца играчи. Лицитирај, избери адут и земи штихови — првиот до 101 поен победува.",
  "login.linkRules": "Правила",
  "login.linkStrategy": "Стратегија",
  "login.linkAbout": "За играта",
  "login.linkPrivacy": "Приватност",

  "lobby.entryFee": (p: { fee: number }) => `Влезница по партија: ${p.fee} ${coinWord(p.fee)}`,
  "lobby.resumeMatch": "Продолжи партија",
  "lobby.playButton": "Играј (3 играчи)",
  "lobby.inviteFriend": "📣 Покани пријател",
  "lobby.insufficientFunds": (p: { missing: number }) => `Немаш доволно монети за влезницата (недостигаат ${p.missing}).`,
  "lobby.watchAd": "Погледни реклама за дополнителни монети",

  "leaderboard.title": "🏆 Ранг-листа",
  "leaderboard.emptySeason": "Сè уште нема рангирани играчи оваа сезона (потребно е да се одигра барем 1 партија).",
  "leaderboard.emptyGlobal": "Сè уште нема рангирани играчи (потребно е да се одигра барем 1 партија вкупно).",
  "leaderboard.seasonTabDefault": "Сезона",
  "leaderboard.seasonTabWithDate": (p: { month: string; year: string }) => `Сезона ${p.month}/${p.year}`,
  "leaderboard.globalTab": "🌍 Вкупно (сите сезони)",
  "leaderboard.colPlayer": "Играч",
  "leaderboard.colPoints": "Поени",
  "leaderboard.colMatches": "Партии",
  "leaderboard.you": "Ти",
  "leaderboard.yourScoreUnranked": (p: { points: number; matchesPlayed: number }) =>
    `Твој резултат: ${p.points} поени од ${p.matchesPlayed} партии (потребна е барем 1 партија за ранг)`,

  "rules.title": "📖 Како се игра Мексико",
  "rules.cardsHeading": "Карти",
  "rules.cardsBody":
    "Се игра со 32 карти (7, 8, 9, 10, J, Q, K, A во сите 4 бои). Јачина на картите во рамките на бојата, од најслаба: 7 &lt; 8 &lt; 9 &lt; 10 &lt; J &lt; Q &lt; K &lt; A. Адутската боја ги победува сите неадутски карти, без разлика на рангот.",
  "rules.dealingHeading": "Делење",
  "rules.dealingBody": "Секој од 3-те играчи добива 10 карти (во два круга по 5), а 2 карти остануваат скриени во „купот“.",
  "rules.biddingHeading": "Наддавање",
  "rules.biddingBody":
    "Првиот играч мора да наддава најмалку 5. Секој следен мора да наддава строго повеќе (5, 6, 7, 8, 9, 10, или „МЕКСИКО“) или да рече „понатаму“ — кој еднаш ќе рече „понатаму“, трајно испаѓа од наддавањето за тоа делење. Наддавањето завршува кога ќе остане само еден играч.",
  "rules.talonHeading": "Куп и отфрлање",
  "rules.talonBody":
    "Победникот во наддавањето го отвора купот (2 карти, видливи за сите), ги додава во својата рака (сега има 12 карти), па отфрла 2 карти со лицето надолу. Потоа го бира адутот.",
  "rules.mexicoHeading": "МЕКСИКО (20)",
  "rules.mexicoBody":
    "Кој наддава „МЕКСИКО“, се обврзува да ги земе сите 10 штихови. Се игра без адут и без куп — само со оригиналните 10 карти.",
  "rules.tricksHeading": "Тек на игра (штихови)",
  "rules.tricksBody":
    "Мора да се следи изнесената боја ако ја имаш. Ако ја немаш, мораш да фрлиш адут ако имаш (сечење) — само ако немаш ниту едно ниту друго, можеш да фрлиш што било. Најсилната карта од изнесената боја го носи штихот, освен ако некој фрлил адут — тогаш најсилниот адут го носи штихот, без разлика на бојата. Кој го земе штихот, води во следниот.",
  "rules.scoringHeading": "Бодување",
  "rules.scoringBody":
    "Победникот во наддавањето: ако земе барем онолку штихови колку што наддавал, добива онолку поени колку што реално земал. Ако не успее, добива <strong>негативни</strong> поени во висина на наддавањето. Другите два играчи секогаш добиваат поени еднакви на бројот на штихови што ги земале.",
  "rules.matchEndHeading": "Крај на партијата",
  "rules.matchEndBody":
    "Партијата завршува кога некој ќе го достигне целниот резултат. Ако повеќе играчи ја поминат целта во истото делење со ист највисок резултат, се игра дополнително делење додека не се разреши.",

  "settings.soundOff": "🔇 Звук исклучен",
  "settings.soundOn": "🔊 Звук вклучен",
  "settings.displayNameLabel": "Име во играта",
  "settings.saveDisplayName": "Зачувај име",
  "settings.displayNameLengthError": "Името мора да има 1-20 карактери.",
  "settings.saveFailed": "Зачувувањето не успеа, обиди се повторно.",
  "settings.logout": "🚪 Одјави се",

  "waitingRoom.waitingForPlayers": (p: { filled: number; total: number }) => `Чекање играчи... ${p.filled}/${p.total}`,
  "waitingRoom.countdown": (p: { remainingSec: number }) => `Преостануваат ${p.remainingSec}с пред AI да ги пополни празните места`,

  "game.passLabel": "понатаму",
  "game.passButton": "Понатаму",
  "game.mexicoLabel": "МЕКСИКО",
  "game.bidLabel": (p: { bid: string }) => `Наддавање: ${p.bid}`,
  "game.trumpLabel": (p: { suit: string }) => `Адут: ${p.suit}`,
  "game.tricksWonLabel": (p: { count: number }) => `Штихови: ${p.count}`,
  "game.biddingInProgress": "Наддавањето е во тек...",
  "game.yourBid": "Твое наддавање",
  "game.someoneDiscarding": (p: { name: string }) => `${p.name} отфрла карти...`,
  "game.someoneChoosingTrump": (p: { name: string }) => `${p.name} го бира адутот...`,
  "game.chooseTrumpPrompt": "Избери адут",
  "game.nextDealPause": "Следно делење...",
  "game.fromTalon": "од купот",
  "game.talonRevealLabel": (p: { bidder: string }) => `Карти од купот (${p.bidder})`,
  "game.yourTurnLabel": "Твој потег",
  "game.turnTimerLabel": (p: { name: string; remainingSec: number }) => `${p.name} — ${p.remainingSec}с`,
  "game.idleBotTakeover": "🤖 Не одигра навреме, па AI сега игра наместо тебе. Кликни каде било за да ја преземеш контролата.",
  "game.leaveMatch": "Напушти партија",
  "game.cardAlt": "карта",
  "game.botDisplayName": "AI играч",
  "game.botBadgeIdle": "🤖 AI (привремено)",
  "game.botBadgeFull": "🤖 БОТ",
  "game.declarerTooltip": "Го води наддавањето",

  "matchEnd.title": "Партијата заврши",
  "matchEnd.winner": (p: { name: string }) => `Победник: ${p.name}`,
  "matchEnd.backToLobby": "Назад во лоби",

  "reactions.sendButton": "Испрати реакција",
  "reaction.angry_small_card": "Зошто со мала карта?",
  "reaction.angry_big_card": "Зошто со голема карта?",
  "reaction.bravo": "Браво",
  "reaction.svaka_cast": "Капа долу",
  "reaction.cestitam_pobeda": "Честитки за победата",
  "reaction.izvini": "Извини",
  "reaction.pa_zasto": "Па зошто!",
  "reaction.srecan": "",
  "reaction.srce": "",
  "reaction.pozdrav": "",

  "medal.season_gold": "🥇 Сезона",
  "medal.season_silver": "🥈 Сезона",
  "medal.season_bronze": "🥉 Сезона",
  "medal.first_match": "🎉 Прва партија",
  "medal.matches_100": "💯 100 партии",
  "medal.mexico_master": "🌵 Мексико мајстор",
  "medal.hat_trick_3_wins": "🔥 Хетрик (3 победи)",
  "medal.tricks_1000": "🃏 1000 штихови",

  "suit.diamonds": "Каро",
  "suit.hearts": "Срце",
  "suit.clubs": "Треф",
  "suit.leaves": "Лист",

  "profile.matchesPlayed": "Одиграни партии",
  "profile.firstPlace": (p: { wins: number }) => `🥇 1. место (${p.wins})`,
  "profile.secondPlace": (p: { count: number }) => `🥈 2. место (${p.count})`,
  "profile.thirdPlace": (p: { count: number }) => `🥉 3. место (${p.count})`,
  "profile.pointsConfigNote": (p: { win: number; second: number; third: number }) =>
    `Бодување по партија: 1. место ${p.win}, 2. место ${p.second}, 3. место ${p.third} поени`,
  "profile.noMedals": "Сè уште нема освоени медали.",
  "profile.medalsHeading": "Медали",
  "profile.seasonHistoryHeading": "Историја на сезони",
  "profile.colSeason": "Сезона",
  "profile.colRank": "Ранг",
  "profile.deleteAccountButton": "🗑️ Избриши ја сметката",
  "profile.deleteAccountTitle": "Избриши ја сметката",
  "profile.deleteAccountWarning":
    "Ова трајно ги брише твојата сметка и сите податоци (историјата на партии, ранг-листата, медалите, состојбата на монети). Оваа акција не може да се врати.",
  "profile.deleteAccountConfirm": "Да, избриши ја сметката",
  "profile.deleteAccountFailed": "Бришењето не успеа, обиди се повторно.",
  "profile.deleteAccountActiveMatch": "Не можеш да ја избришеш сметката додека си во активна партија. Заврши ја или напушти ја партијата па обиди се повторно.",

  "errors.NOT_YOUR_TURN": "Не е твој ред.",
  "errors.INVALID_BID": "Невалидно наддавање.",
  "errors.BID_TOO_LOW": "Наддавањето мора да биде поголемо од тековно највисокото.",
  "errors.MUST_BID_FIRST": "Првиот играч мора да наддава најмалку 5, не може да рече понатаму.",
  "errors.DUPLICATE_DISCARD": "Не можеш да ја отфрлиш истата карта двапати.",
  "errors.CARD_NOT_IN_HAND": "Таа карта не е во твојата рака.",
  "errors.MUST_FOLLOW_SUIT": "Мораш да ја следиш бојата, или да сечеш со адут ако не можеш.",
  "errors.TRICK_INCOMPLETE": "Штихот сè уште не е завршен.",
  "errors.MATCH_ENDED": "Партијата веќе заврши.",
  "errors.UNKNOWN_ACTION": "Непозната акција.",
  "errors.WRONG_PHASE": "Таа акција не е дозволена во оваа фаза од играта.",
  "errors.NOT_BID_WINNER": "Само победникот во наддавањето може да го стори тоа.",
  "errors.MATCH_NOT_ENDED": "Партијата сè уште не заврши.",
  "errors.invalid_session_token": "Сесијата истече, најави се повторно.",
  "errors.room_full": "Масата е полна, обиди се повторно за момент.",
  "errors.insufficient_balance": "Немаш доволно монети за влезницата.",
  "errors.ad_unavailable": "Рекламата моментално не е достапна. Провери ја интернет конекцијата (или исклучи го AdBlock) и обиди се повторно.",
  "errors.invalid_or_early_ticket": "Рекламата не е препознаена како гледана. Обиди се повторно.",
  "errors.daily_ad_limit_reached": "Го достигна дневниот лимит на реклами. Обиди се утре.",

  "share.inviteText": "Играј Мексико со мене!",
  "ad.placeholderText": "Симулирана реклама (standalone веб демо)",
  "rotateOverlay.text": "Сврти го телефонот за да играш Мексико",
  "languageSwitcher.ariaLabel": "Јазик",
} satisfies TranslationCatalog;
